var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-field',[_c('md-input',{staticClass:"mb-3",staticStyle:{"width":"200px"},attrs:{"type":"search","clearable":"","placeholder":_vm.$t('label.search_records'),"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }